import React from 'react';
import { cn } from '@/lib/utils';

// Convert snake_case to Title Case
const toTitleCase = (str) => {
    if (!str) return 'N/A';

    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

// Map status to custom styles
const getStatusStyles = (status) => {
    const statusLower = status?.toLowerCase() || '';

    // Status to custom styling mapping
    const styleMap = {
        // Queue statuses (slate/gray colors)
        'added_to_process_queue': 'bg-slate-100 text-slate-800 border-slate-300',
        'added_to_signup_queue': 'bg-slate-200 text-slate-800 border-slate-400',
        'added_to_profile_queue': 'bg-slate-300 text-slate-800 border-slate-500',

        // Automation/Processing statuses (orange/blue/indigo colors)
        'automation_started': 'bg-orange-100 text-orange-800 border-orange-300',
        'signup_automation_started': 'bg-orange-200 text-orange-800 border-orange-400',
        'profile_automation_started': 'bg-orange-300 text-orange-800 border-orange-500',

        // New status
        'new': 'bg-blue-100 text-blue-800 border-blue-300',

        // Payment statuses (amber/emerald colors)
        'pending_payment': 'bg-amber-100 text-amber-800 border-amber-300',
        'portal_fee_payment_pending': 'bg-amber-200 text-amber-800 border-amber-400',
        'payment_received': 'bg-emerald-100 text-emerald-800 border-emerald-300',

        // Review statuses (purple colors)
        'in_review': 'bg-purple-100 text-purple-800 border-purple-300',

        // Hold/Pending statuses (yellow/gray colors)
        'on_hold': 'bg-yellow-100 text-yellow-800 border-yellow-300',

        // Success statuses (green/teal colors)
        'permit_ready': 'bg-teal-100 text-teal-800 border-teal-300',
        'permit_processing': 'bg-teal-200 text-teal-800 border-teal-400',
        'completed': 'bg-green-100 text-green-800 border-green-300',

        // Failed/Error statuses (red/rose colors)
        'automation_failed': 'bg-red-100 text-red-800 border-red-300',
        'portal_signup_failed': 'bg-red-200 text-red-800 border-red-400',
        'portal_profile_failed': 'bg-red-300 text-red-800 border-red-500',
        'rejected': 'bg-red-400 text-red-800 border-red-600',
        'pending_zermit_fees': 'bg-gray-100 text-gray-800 border-gray-300',
        'zermit_fees_paid': 'bg-emerald-100 text-emerald-800 border-emerald-300',
        'in_progress': 'bg-amber-100 text-amber-800 border-amber-300',
        'awaiting_city_payment': 'bg-blue-100 text-blue-800 border-blue-300',
        'under_ahj_review': 'bg-purple-100 text-purple-800 border-purple-300',
    };

    return styleMap[statusLower] || 'bg-gray-100 text-gray-800 border-gray-300';
};

const PermitStatusBadge = ({ status, className = '' }) => {
    if (!status) {
        return (
            <span className={cn(
                'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold',
                'bg-gray-50 text-gray-600 border-gray-200',
                className
            )}>
                N/A
            </span>
        );
    }

    const styles = getStatusStyles(status);
    const displayText = toTitleCase(status);

    return (
        <span className={cn(
            'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold transition-colors',
            styles,
            className
        )}>
            {displayText}
        </span>
    );
};

export default PermitStatusBadge;

